import newTreatment from "./newTreatmentSchema";
import newTreatmentType from "./newTreatmentTypeSchema";
import followUpNote from "./followUpNoteSchema";

export const treatmentSchemas = {
  newTreatment,
  newTreatmentType,
  followUpNote
};
